import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

interface ParamsGetTotems {
    storeId?: number;
    enabled?: boolean;
}

export interface ResponseTotem {
    id: number;
    store_id: number;
    android_uid: string;
    nome: string;
    serial_id: string;
    created_at: string;
    deleted_at: string;
    updated_at: string;
    last_log_id: number;
    hardware_model: string;
}

export function useGetTotems({ storeId, enabled = true }: ParamsGetTotems) {
    const queryFn = async () => {
        const totems: { data: ResponseTotem[] } = await api.get(
            `/totem/${storeId}`,
        );
        return totems.data;
    };

    return useQuery({
        queryKey: ['GET_TOTEMS', storeId],
        queryFn,
        enabled: !!storeId && enabled,
    });
}
